<template>
  <section class="page404">
    <div class="page404__info">
      <div class="page404__info-logo" @click="goHome" />
      <div class="page404__info-picture">
        <img src="@/assets/img/new-404-picture.png" alt="404">
      </div>
      <div class="page404__info-title">404</div>
      <div class="page404__info-subtitle">Страница не найдена</div>
      <div class="page404__info-description">
        Возможно, запрошенная страница временно не доступна или удалена
      </div>
    </div>
    <new-button
      title="На главную"
      type="primary"
      class="page404__button"
      @button-clicked="goHome"
    />
  </section>
</template>

<script>
import NewButton from "@/components/Drivers/NewButton/NewButton";
export default {
  name: 'Page404',
  components: { NewButton },
  methods: {
    goHome() {
      this.$router.push({ name: 'Home' })
    },
  },
}
</script>

<style lang="sass" scoped>
.page404
  display: flex
  flex-direction: column
  justify-content: space-between
  align-items: center
  height: calc(100vh - 7rem)
  padding-top: 3.2rem
  &__info
    display: flex
    flex-direction: column
    align-items: center
    &-logo
      width: 18.7rem
      height: 3.3rem
      margin-bottom: 2.4rem
      background: url("~@/assets/img/new-logo.svg")
      background-size: cover
      cursor: pointer
      img
        width: 100%
        height: 100%
    &-picture
      width: 22rem
      height: 22rem
      margin-bottom: 2rem
      img
        width: 100%
        height: 100%
    &-title
      margin-bottom: .8rem
      font-size: 4.8rem
      font-weight: 800
      line-height: 5.6rem
      color: #181818
    &-subtitle
      margin-bottom: .8rem
      font-size: 2.4rem
      font-weight: 800
      line-height: 3.2rem
      color: #181818
    &-description
      padding: 0 4.5rem
      font-size: 1.6rem
      font-weight: 400
      line-height: 2rem
      color: #5C5C5C

  ::v-deep &__button .new-button
    width: 22rem
    margin-bottom: 4.1rem

</style>
